import { render, staticRenderFns } from "./ShareAudioPlayer.vue?vue&type=template&id=2d959161&scoped=true"
import script from "./ShareAudioPlayer.vue?vue&type=script&lang=js"
export * from "./ShareAudioPlayer.vue?vue&type=script&lang=js"
import style0 from "./ShareAudioPlayer.vue?vue&type=style&index=0&id=2d959161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d959161",
  null
  
)

export default component.exports